<!-- @format -->

<div class="plp-srlp-compare-thumbnail hmf-pt-xs hmf-pr-xs hmf-position-relative">
	<img
		class="compare-thumbnail-image"
		title="Compare thumbnail {{ compareData?.name }}"
		[src]="compareData?.imgURL"
		[alt]="compareData?.name" />
	<button
		hmf-button
		class="compare-remove-button hmf-position-absolute hmf-p-xxs"
		title="Remove product from Compare List"
		[label]="'Remove product from Compare List'"
		[variant]="'secondary'"
		(click)="onRemove()">
		<homefield-icon
			name="sign-cancel"
			width="16"
			height="16"></homefield-icon>
	</button>
</div>
